module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-week-b9d56423.svg";